import { TeaserCardSlider } from './TeaserCardSlider';
import register from './register';

register(TeaserCardSlider);
